import { call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import { machineryManagementActions } from '../reducers/machinery-management';
import machineryManagementService from '../api/machineryManagement';

function* machineryManagementDataRequest({ payload }: any): any {
  const res = yield call(machineryManagementService.fetchMachineData, payload);
  if (res.status === 'success') {
    yield put(machineryManagementActions.getMachineryManagementDataResponse(res?.data));
  } else {
    yield put(machineryManagementActions.getMachineryManagementDataFailed(res?.code));
  }
}

function* addMachineryManagement({ payload }: any): any {
  const res = yield call(machineryManagementService.addMachine, payload);
  if (res.status === 'success') {    
    yield put(machineryManagementActions.addMachineResponse(res?.code));
  } else {
    yield put(machineryManagementActions.addMachineFailed(res?.code));
  }
}

function* updateMachineryManagement({ payload }: any): any {
  const res = yield call(machineryManagementService.updateMachine, payload);
  if (res.status === 'success') {
    yield put(machineryManagementActions.updateMachineResponse(res?.code));
  } else {
    yield put(machineryManagementActions.updateMachineFailed(res?.code));
  }
}

function* deleteMachineryManagement({ payload }: any): any {
  const res = yield call(machineryManagementService.deleteMachine, payload);
  if (res.status === 'success') {
    yield put(machineryManagementActions.deleteMachineResponse(res?.code));
  } else {
    yield put(machineryManagementActions.deleteMachineFailed(res?.code));
  }
}

function* bulkUploadData({ payload }: any): any {
  const res = yield call(machineryManagementService.bulkUpload, payload);
  if (res.status === 'success') {
    yield put(machineryManagementActions.bulkUploadResponse(res?.code));
  } else {
    yield put(machineryManagementActions.bulkUploadFailed(res?.code));
  }
}

function* machineryManagementSaga() {
  yield takeLatest('machineryManagement/getMachineryManagementDataRequest', machineryManagementDataRequest);
  yield takeLeading('machineryManagement/addMachineRequest', addMachineryManagement);
  yield takeLeading('machineryManagement/deleteMachineRequest', deleteMachineryManagement);
  yield takeLeading('machineryManagement/updateMachineRequest', updateMachineryManagement);
  yield takeLeading('machineryManagement/bulkUploadRequest', bulkUploadData);
}

export default machineryManagementSaga;
